import fastdom from 'fastdom'
import { ChangeDetectionStrategy, Component, ElementRef, Input, ViewChild } from '@angular/core'
import { AssetMini, AssetMiniFromJSON } from 'elements-sdk'

@Component({
  selector: 'audio-thumbnail',
  template: `
    <img #strip class="strip" [src]="asset.defaultProxy?.urls.strip" />
  `,
  styleUrls: ['./audioThumbnail.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AudioThumbnailComponent {
  @Input() asset: AssetMini
  @Input() time = 0

  @ViewChild('strip') private strip: ElementRef<HTMLImageElement>

  constructor (private element: ElementRef<HTMLElement>) { }

  ngAfterViewInit () {
    this.strip.nativeElement.addEventListener('load', () => this.refresh())
  }

  ngOnChanges (changes) {
    if ('default_proxy' in this.asset) {
      this.asset = AssetMiniFromJSON(this.asset)
    }
    if (this.asset.type !== 'audio') {
      throw new Error('Asset is not an audio')
    }
    if (changes.time) {
      this.refresh()
    }
  }

  refresh () {
    fastdom.measure(() => {
      const stripWidth = this.strip.nativeElement.width
      const thumbnailWidth = this.element.nativeElement.clientWidth
      const pc = this.time / this.asset.format.duration!
      const dx = (stripWidth - thumbnailWidth) * pc
      fastdom.mutate(() => {
        this.strip.nativeElement.style.transform = `translate(${-dx}px, 0)`
      })
    })
  }
}
